import { AnyAction, Reducer } from 'redux';

export const STORE_PAYMENT_DATA = 'store/payment-data';
export const STORE_INVOICE_DATA = 'store/invoice-data';
export const STORE_PROGRESS_ISWAITING = 'store/progress-waiting';
export const STORE_PAYMENT_ROWDATA = 'store/payment-rowdata';
export const STORE_PAYMENT_ID = 'store/payment-id';
export const STORE_RETURN_TRANSACTION_ID = 'store/transaction-return-from-payment-id';
export const STORE_RETURN_TRANSACTION_STATUS = 'store/transaction-return-from-payment-STATUS';
export const STORE_RETURN_TRANSACTION_STATUS_DESC = 'store/transaction-return-from-payment-STATUS-description';
export const STORE_RETURN_TRANSACTION_PAY_U_ID = 'payu id/transaction-return-from-payment-STATUS-description';
export const STORE_RETURN_TRANSACTION_TXN_AMT = 'transaction amount/transaction-return-from-payment-STATUS-description';
export const STORE_RETURN_TRANSACTION_AXPERROR = 'Axpert Error/transaction-return-from-payment-error-while-hitting-axpert';
export const STORE_P_STARTDATE = 'payment invoice - filter - STARTDATE';
export const STORE_P_START_TIME = 'payment invoice - filter - START_TIME';
export const STORE_P_ENDDATE = 'payment invoice - filter - ENDDATE';
export const STORE_P_END_TIME = 'payment invoice - filter - END_TIME';
// export const STORE_PAYMENT_AMOUNT = 'store/payment-amount';
// export const STORE_PAYMENT_UNITS = 'store/payment-units';

export interface PaymentData {
    rowno: string;
    custcode: string;
    invoiceno: string;
    invoicedate: string;
    currency: string;
    invamount: string;
    settled: string;
    outstanding: string;
    column1: string;
    duedate: string;
    orderno: string;
    service_name: string;
    tattype: string;
    totunits: string;
    //     invoiceno: string;
    // invoicedate: string;
    // business: string;
    // date: string;
    // amount: string;
}

export interface InvoiceData {
    invoiceno: string;
    settledamt: string;
}

export interface PaymentState {
    getPaymentData: PaymentData[];
    invoiceData: InvoiceData[];
    isWaiting: boolean;
    paymentId: string;
    returnTransactionId: string;
    returnTransactionStatus: boolean;
    paymentStatus: string;
    txnid: string;
    txnamt: string;
    axperror: string;
    startPDate: Date | null;
    startPTime: Date | null;
    endPDate: Date | null;
    endPTime: Date | null;
    // paymentAmount: number;
    // unitTotal: number;
}

const initialState: PaymentState = {
    getPaymentData: [],
    invoiceData: [],
    isWaiting: false,
    paymentId: '',
    returnTransactionId: '',
    returnTransactionStatus: false,
    paymentStatus: '',
    txnid: '',
    txnamt: '',
    axperror: '',
    startPDate: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
    startPTime: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
    endPDate: new Date(),
    endPTime: new Date()
    // paymentAmount: 0,
    // unitTotal: 0
};

const reducer: Reducer<PaymentState> = (state: PaymentState = initialState, action: AnyAction): PaymentState => {
    switch (action.type) {
        case STORE_PAYMENT_DATA:
            return {
                ...state,
                getPaymentData: action.getPaymentData
            };
        case STORE_INVOICE_DATA:
            return {
                ...state,
                invoiceData: action.invoiceData
            };
        case STORE_PROGRESS_ISWAITING:
            return {
                ...state,
                isWaiting: action.isWaiting
            };
        case STORE_PAYMENT_ID:
            return {
                ...state,
                paymentId: action.paymentId
            };
        case STORE_RETURN_TRANSACTION_ID:
            return {
                ...state,
                returnTransactionId: action.returnTransactionId
            };
        case STORE_RETURN_TRANSACTION_STATUS:
            return {
                ...state,
                returnTransactionStatus: action.returnTransactionStatus
            };
        case STORE_RETURN_TRANSACTION_STATUS_DESC:
            return {
                ...state,
                paymentStatus: action.paymentStatus
            };
        case STORE_RETURN_TRANSACTION_PAY_U_ID:
            return {
                ...state,
                txnid: action.txnid
            };
        case STORE_RETURN_TRANSACTION_TXN_AMT:
            return {
                ...state,
                txnamt: action.txnamt
            };
        case STORE_RETURN_TRANSACTION_AXPERROR:
            return {
                ...state,
                axperror: action.axperror
            };
        case STORE_P_STARTDATE:
            return {
                ...state,
                startPDate: action.startPDate
            };
        case STORE_P_START_TIME:
            return {
                ...state,
                startPTime: action.startPTime
            };
        case STORE_P_ENDDATE:
            return {
                ...state,
                endPDate: action.endPDate
            };
        case STORE_P_END_TIME:
            return {
                ...state,
                endPTime: action.endPTime
            };
        // case STORE_PAYMENT_AMOUNT:
        //     return {
        //         ...state,
        //         paymentAmount: action.paymentAmount
        //     };
        // case STORE_PAYMENT_UNITS:
        //     return {
        //         ...state,
        //         unitTotal: action.unitTotal
        //     };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/payment.tsx